(() => {
  const section = document.querySelector('[data-inkybox-cart-related]');
  if (!section) return;

  const grid = section.querySelector('.inkybox-cart-related__grid');
  const limit = 8;
  let requestVersion = 0;
  let currentProducts = '';

  const ids = (value) => [...new Set(String(value || '').split(',').filter(Boolean))];
  const isAddOn = (properties) => {
    const values = properties || {};
    return values._inkybox_item_type === 'addon' || values._is_addon === 'true' ||
      ['_addon_type', '_inkybox_addon_type', '_inkybox_parent_key', '_parentKey', '_parentLineKey', '_add_on_customallcustomid']
        .some((key) => values[key]);
  };

  const primarySources = new Map(
    [...section.querySelectorAll('[data-related-primary-sources] [data-related-metafield-source]')]
      .map((source) => [String(source.dataset.anchorProductId || ''), source])
      .filter(([productId]) => productId)
  );

  const badgeText = (quantity) => {
    if (quantity >= 4) return '';
    if (quantity >= 3) return 'Add to unlock 20% off';
    if (quantity >= 2) return 'Add to unlock 15% off';
    if (quantity === 1) return 'Add to unlock 10% off';
    return 'Add 2 to unlock 10% off';
  };

  const appendRoundRobin = (lists, targetCount, chosen, seen) => {
    for (let index = 0; chosen.length < targetCount && lists.some((list) => index < list.length); index += 1) {
      for (const list of lists) {
        const candidate = list[index];
        const productId = candidate?.productId;
        if (!candidate || !productId || seen.has(productId)) continue;
        seen.add(productId);
        chosen.push(candidate);
        if (chosen.length === targetCount) break;
      }
    }
  };

  async function resolvePrimary(productId, handlesById) {
    const sourceElement = primarySources.get(productId);
    return window.InkyboxRelatedCatalog.resolve({
      sourceElement,
      productId,
      handle: sourceElement?.dataset.anchorProductHandle || handlesById.get(productId) || '',
    });
  }

  async function refresh(productIds, sourceIds, eligibleQuantity, handlesById = new Map()) {
    const version = ++requestVersion;
    const anchors = sourceIds.slice(0, 2);
    const cartHandles = new Set(productIds.map((productId) =>
      handlesById.get(productId) || primarySources.get(productId)?.dataset.anchorProductHandle || ''
    ).filter(Boolean));
    const historyHandles = (window.InkyboxRecentlyViewed?.readHandles?.() || [])
      .filter((handle) => handle && !cartHandles.has(handle))
      .slice(0, 2);
    const key = anchors.join(',') + '|' + historyHandles.join(',') + '|' + productIds.join(',');
    if (key === currentProducts && grid.children.length) {
      updateBadges(eligibleQuantity);
      return;
    }
    currentProducts = key;
    section.hidden = true;
    grid.replaceChildren();
    if (!anchors.length || !window.InkyboxRelatedCatalog) return;

    try {
      const [primaryResults, historyResults] = await Promise.all([
        Promise.all(anchors.map((productId) => resolvePrimary(productId, handlesById))),
        Promise.all(historyHandles.map((handle) => window.InkyboxRelatedCatalog.resolve({ handle }))),
      ]);
      if (version !== requestVersion) return;

      const seen = new Set([
        ...productIds,
        ...historyResults.map((source) => source.anchorProductId).filter(Boolean),
      ]);
      const chosen = [];
      appendRoundRobin(primaryResults.map((source) => source.candidates), 6, chosen, seen);
      appendRoundRobin(historyResults.map((source) => source.candidates), limit, chosen, seen);
      appendRoundRobin([
        ...primaryResults.map((source) => source.candidates),
        ...historyResults.map((source) => source.candidates),
      ], limit, chosen, seen);
      const cards = (await Promise.all(chosen.map((candidate) =>
        window.InkyboxRelatedCatalog.render(candidate, section.dataset.sectionId).catch(() => null)
      ))).filter(Boolean);
      if (version !== requestVersion) return;
      grid.replaceChildren(...cards);
      updateBadges(eligibleQuantity);
      section.hidden = !cards.length;
      if (cards.length) window.initInkyboxCardPreview?.(grid);
    } catch (error) {
      if (version === requestVersion) section.hidden = true;
      console.error(error);
    }
  }

  function updateBadges(quantity) {
    const label = badgeText(quantity);
    grid.querySelectorAll('[data-volume-eligible]').forEach((card) => {
      card.querySelector('.inkybox-cart-related__badge')?.remove();
      if (card.dataset.volumeEligible !== 'true' || !label) return;
      const media = card.querySelector('.card__media');
      if (!media) return;
      const badge = document.createElement('span');
      badge.className = 'inkybox-cart-related__badge';
      badge.textContent = label;
      media.append(badge);
    });
  }

  refresh(
    ids(section.dataset.cartProductIds),
    ids(section.dataset.recommendationProductIds),
    Number(section.dataset.eligibleQuantity) || 0
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const items = event?.cartData?.items;
      if (!items) return;
      const productIds = [...new Set(items.map((item) => String(item.product_id)))];
      const sourceItems = items.filter((item) => !isAddOn(item.properties));
      const sourceIds = [...new Set(sourceItems.map((item) => String(item.product_id)))];
      const handlesById = new Map(sourceItems.map((item) => [
        String(item.product_id),
        String(item.handle || item.product_handle || ''),
      ]));
      const eligibleQuantity = items.reduce((sum, item) => {
        if (isAddOn(item.properties)) return sum;
        return sum + (item.quantity || 0) * Number(
          document.querySelector(`.inkybox-cart__item[data-cart-item-key="${CSS.escape(item.key)}"]`)
            ?.dataset.inkyboxVolumeDiscountEligible === 'true'
        );
      }, 0);
      refresh(productIds, sourceIds, eligibleQuantity, handlesById);
    });
  }
})();
